import React, { useEffect, useMemo, useState, useRef, useCallback } from "react";
import "bulma/css/bulma.css";
import "../../../../../../../index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import { APIMS } from "../../../../../../../config/apims";
import { APISD } from "../../../../../../../config/apisd";
import swal from "sweetalert";
import ModalDetailKoreksiAbsen from "./modal/koreksiAbsen";

/* ===========================
   UI KOREKSI ABSENSI
=========================== */
const css = `
  @keyframes kaShimmer {
    0% { background-position: -700px 0; }
    100% { background-position: 700px 0; }
  }

  @keyframes kaSpin {
    to { transform: rotate(360deg); }
  }

  .ka-page {
    width: 100%;
    min-width: 0;
    padding: 4px 0 28px;
    box-sizing: border-box;
  }

  .ka-filter-card,
  .ka-table-card,
  .ka-loading-card {
    width: 100%;
    min-width: 0;
    border: 1px solid #e5eaf4;
    border-radius: 16px;
    background: #ffffff;
    box-sizing: border-box;
  }

  .ka-filter-card {
    margin-bottom: 18px;
    padding: 18px;
    box-shadow: 0 4px 18px rgba(39, 71, 140, 0.05);
  }

  .ka-filter-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    margin-bottom: 17px;
  }

  .ka-filter-title-wrap {
    display: flex;
    min-width: 0;
    align-items: center;
    gap: 11px;
  }

  .ka-filter-icon {
    display: inline-flex;
    width: 38px;
    height: 38px;
    flex: 0 0 38px;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: #eef3ff;
    color: #4362e8;
  }

  .ka-filter-title {
    margin: 0;
    color: #17213d;
    font-size: 15px;
    font-weight: 700;
    line-height: 1.3;
  }

  .ka-filter-subtitle {
    margin: 3px 0 0;
    color: #8792aa;
    font-size: 12px;
    line-height: 1.4;
  }

  .ka-filter-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 14px;
    align-items: end;
  }

  .ka-field {
    min-width: 0;
  }

  .ka-label {
    display: block;
    margin-bottom: 7px;
    color: #4c5870;
    font-size: 12px;
    font-weight: 700;
  }

  .ka-select-wrap {
    position: relative;
  }

  .ka-select-wrap::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 14px;
    width: 7px;
    height: 7px;
    border-right: 1.7px solid #72809a;
    border-bottom: 1.7px solid #72809a;
    transform: translateY(-68%) rotate(45deg);
    pointer-events: none;
  }

  .ka-select {
    width: 100%;
    height: 43px;
    padding: 0 38px 0 13px;
    border: 1px solid #dce3ef;
    border-radius: 10px;
    outline: none;
    appearance: none;
    -webkit-appearance: none;
    background: #ffffff;
    color: #2f3a50;
    font-size: 13px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  .ka-select:hover:not(:disabled) {
    border-color: #bac8e1;
  }

  .ka-select:focus {
    border-color: #7892ff;
    box-shadow: 0 0 0 3px rgba(63, 91, 234, 0.08);
  }

  .ka-select:disabled {
    background: #f6f8fb;
    color: #9aa5b6;
    cursor: not-allowed;
  }

  .ka-filter-actions {
    // display: flex;
    // justify-content: flex-end;
    gap: 10px;
    margin-top: 15px;
  }

  .ka-btn {
    display: inline-flex;
    min-height: 40px;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 9px 16px;
    border: 1px solid transparent;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    transition: transform 0.15s ease, background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
  }

  .ka-btn:hover:not(:disabled) {
    transform: translateY(-1px);
  }

  .ka-btn:disabled {
    cursor: not-allowed;
    opacity: 0.55;
    transform: none;
  }

  .ka-btn-filter {
    min-width: 112px;
    border-color: #e9a51a;
    background: #e9a51a;
    color: #ffffff;
    box-shadow: 0 5px 12px rgba(233, 165, 26, 0.18);
  }

  .ka-btn-filter:hover:not(:disabled) {
    border-color: #d89512;
    background: #d89512;
  }

  .ka-btn-download {
    border-color: #4362e8;
    background: #4362e8;
    color: #ffffff;
    box-shadow: 0 5px 12px rgba(67, 98, 232, 0.17);
  }

  .ka-btn-download:hover:not(:disabled) {
    border-color: #354fca;
    background: #354fca;
  }

  .ka-spinner {
    width: 14px;
    height: 14px;
    border: 2px solid rgba(255, 255, 255, 0.45);
    border-top-color: #ffffff;
    border-radius: 50%;
    animation: kaSpin 0.7s linear infinite;
  }

  .ka-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    margin: 0 0 12px;
  }

  .ka-search-wrap {
    position: relative;
    width: min(100%, 370px);
  }

  .ka-search-icon {
    position: absolute;
    top: 50%;
    left: 14px;
    color: #7d89a2;
    transform: translateY(-50%);
    pointer-events: none;
  }

  .ka-search-input {
    width: 100%;
    height: 44px;
    padding: 0 15px 0 42px;
    border: 1px solid #dde4f0;
    border-radius: 12px;
    outline: none;
    background: #ffffff;
    color: #17213d;
    font-size: 13px;
    box-sizing: border-box;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  .ka-search-input::placeholder {
    color: #9aa5bd;
  }

  .ka-search-input:focus {
    border-color: #7892ff;
    box-shadow: 0 0 0 3px rgba(63, 91, 234, 0.08);
  }

  .ka-total-badge {
    display: inline-flex;
    min-height: 42px;
    align-items: center;
    padding: 8px 12px;
    border: 1px solid #e1e7f1;
    border-radius: 9px;
    background: #f8faff;
    color: #64718a;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
  }

  .ka-table-card {
    overflow: hidden;
  }

  .ka-table-scroll {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }

  .ka-table {
    width: 100%;
    min-width: 760px;
    margin: 0;
    border-collapse: separate;
    border-spacing: 0;
    table-layout: fixed;
  }

  .ka-table th,
  .ka-table td {
    vertical-align: middle;
  }

  .ka-table thead th {
    height: 54px;
    padding: 14px 18px;
    border: 0;
    background: #f3f5ff;
    color: #25345f;
    font-size: 13px;
    font-weight: 700;
    text-align: left;
    white-space: nowrap;
  }

  .ka-table tbody td {
    height: 62px;
    padding: 13px 18px;
    border: 0;
    border-top: 1px solid #e9edf5;
    background: #ffffff;
    color: #2b3654;
    font-size: 13px;
  }

  .ka-table tbody tr:first-child td {
    border-top: 0;
  }

  .ka-table tbody tr:hover td {
    background: #fafbff;
  }

  .ka-col-number {
    width: 82px;
    text-align: center !important;
  }

  .ka-col-name {
    width: auto;
  }

  .ka-col-count {
    width: 105px;
    text-align: center !important;
  }

  .ka-col-action {
    width: 130px;
    text-align: center !important;
  }

  .ka-number-badge {
    display: inline-flex;
    width: 30px;
    height: 30px;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    background: #f1f4ff;
    color: #4362e8;
    font-size: 13px;
    font-weight: 700;
    box-shadow: inset 0 0 0 1px #e6ebfb;
  }

  .ka-student-name {
    display: block;
    color: #24314e;
    font-size: 13px;
    font-weight: 700;
    line-height: 1.45;
    white-space: normal;
    overflow-wrap: break-word;
  }

  .ka-count-badge {
    display: inline-flex;
    min-width: 34px;
    height: 30px;
    align-items: center;
    justify-content: center;
    padding: 0 9px;
    border-radius: 8px;
    background: #f7f9fd;
    color: #42506a;
    font-size: 12.5px;
    font-weight: 700;
    box-shadow: inset 0 0 0 1px #e5eaf3;
  }

  .ka-action-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ka-action-button {
    display: inline-flex;
    min-height: 36px;
    align-items: center;
    justify-content: center;
    gap: 7px;
    padding: 8px 12px;
    border: 1px solid #ffd15e;
    border-radius: 10px;
    background: #ffffff;
    color: #e9a51a;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    transition: transform 0.2s ease, background 0.2s ease;
  }

  .ka-action-button:hover {
    background: #fffaf0;
    transform: translateY(-1px);
  }

  .ka-empty-state {
    padding: 42px 18px !important;
    color: #8994ad !important;
    font-size: 13px !important;
    text-align: center !important;
  }

  .ka-pagination {
    display: flex;
    min-height: 70px;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 14px 20px;
    border-top: 1px solid #edf0f5;
    background: #ffffff;
  }

  .ka-pagination-left,
  .ka-pagination-right,
  .ka-page-numbers {
    display: flex;
    align-items: center;
    gap: 9px;
  }

  .ka-page-info {
    color: #64708d;
    font-size: 12px;
    white-space: nowrap;
  }

  .ka-page-info b {
    color: #2b3758;
    font-weight: 700;
  }

  .ka-page-size {
    height: 40px;
    min-width: 138px;
    padding: 0 34px 0 12px;
    border: 1px solid #dfe5f0;
    border-radius: 10px;
    outline: none;
    background: #ffffff;
    color: #2d3856;
    font-size: 12px;
    font-weight: 600;
  }

  .ka-page-btn {
    display: inline-flex;
    height: 38px;
    min-width: 38px;
    align-items: center;
    justify-content: center;
    padding: 0 11px;
    border: 1px solid #dfe5f0;
    border-radius: 9px;
    background: #ffffff;
    color: #64708d;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
  }

  .ka-page-btn:hover:not(:disabled) {
    border-color: #a9b7f8;
    color: #4362e8;
  }

  .ka-page-btn.active {
    border-color: #4362e8;
    background: #4362e8;
    color: #ffffff;
    box-shadow: 0 5px 12px rgba(63, 91, 234, 0.16);
  }

  .ka-page-btn:disabled {
    cursor: not-allowed;
    color: #c1c8d7;
    background: #fafbfe;
  }

  .ka-shimmer {
    position: relative;
    overflow: hidden;
    background: linear-gradient(90deg, #e9eff8 8%, #f7f9fd 18%, #e9eff8 33%);
    background-size: 1100px 100%;
    animation: kaShimmer 1.25s linear infinite;
  }

  .ka-shimmer-label {
    width: 68px;
    height: 10px;
    margin-bottom: 8px;
    border-radius: 5px;
  }

  .ka-shimmer-control {
    width: 100%;
    height: 43px;
    border-radius: 10px;
  }

  .ka-shimmer-button {
    width: 112px;
    height: 40px;
    border-radius: 10px;
  }

  .ka-loading-card {
    overflow: hidden;
  }

  .ka-loading-head {
    height: 54px;
    border-bottom: 1px solid #e5ebf4;
    background: #f3f5ff;
  }

  .ka-loading-row {
    display: grid;
    grid-template-columns: 82px minmax(220px, 1fr) repeat(4, 105px) 130px;
    gap: 0;
    min-width: 760px;
    align-items: center;
    padding: 14px 18px;
    border-bottom: 1px solid #edf0f5;
  }

  .ka-loading-row:last-child {
    border-bottom: 0;
  }

  .ka-loading-line {
    height: 12px;
    border-radius: 6px;
  }

  .ka-loading-line.no { width: 30px; justify-self: center; }
  .ka-loading-line.name { width: 58%; }
  .ka-loading-line.count { width: 34px; justify-self: center; }
  .ka-loading-line.action { width: 76px; justify-self: center; }

  @media (max-width: 1180px) {
    .ka-filter-grid {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }

  @media (max-width: 780px) {
    .ka-page {
      padding-top: 0;
    }

    .ka-filter-card,
    .ka-table-card,
    .ka-loading-card {
      border-radius: 13px;
    }

    .ka-filter-card {
      padding: 15px;
    }

    .ka-filter-header {
      align-items: flex-start;
      margin-bottom: 15px;
    }

    .ka-filter-grid {
      grid-template-columns: 1fr;
      gap: 12px;
    }

    .ka-filter-actions {
      align-items: stretch;
      flex-direction: column;
    }

    .ka-btn-filter,
    .ka-btn-download {
      width: 100%;
    }

    .ka-toolbar {
      align-items: stretch;
      flex-direction: column;
    }

    .ka-search-wrap {
      width: 100%;
    }

    .ka-total-badge {
      justify-content: center;
    }

    .ka-pagination {
      align-items: stretch;
      flex-direction: column;
      padding: 14px;
    }

    .ka-pagination-left,
    .ka-pagination-right {
      justify-content: space-between;
    }
  }

  @media (max-width: 480px) {
    .ka-filter-title {
      font-size: 14px;
    }

    .ka-filter-subtitle {
      font-size: 11px;
    }

    .ka-pagination-right {
      align-items: stretch;
      flex-direction: column;
    }

    .ka-page-numbers {
      justify-content: center;
      flex-wrap: wrap;
    }
  }
`;

const FilterIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M4 6h16M7 12h10M10 18h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const SearchIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
    <path d="m20 20-3.5-3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const DownloadIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 3v11m0 0 4-4m-4 4-4-4M5 18v3h14v-3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function KonfigurasiPasscode() {
  document.title = "Koreksi Absensi";
  
    const [page] = useState(1);
    const [limit] = useState(1000);
    const [ascending] = useState(1);
    const token = localStorage.getItem("token");
    const [loading, setLoading] = useState(false);
    const [loadingSchool, setLoadingSchool] = useState(false);

    const firstLoadDone = useRef(false);
    const initSchoolDone = useRef(false);
    const initLevelDone = useRef(false);
    const initKelasDone = useRef(false);

    const storageLevel = localStorage.getItem("level");

    const id_user = localStorage.getItem("id_admin") || "";
    const output_id_user = id_user.replace(/[|&;$%@"<>()+,]/g, "");
    
    // Data master
    const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
    const [getDataBranch, setGetDataBranch] = useState([]);
    const [getDataSchool, setGetDataSchool] = useState([]);
    
    // Tingkatan & Kelas
    const [getDataLevel, setGetDataLevel] = useState([]);
    const [getDataKelas, setGetDataKelas] = useState([]);
    const [loadingLevel, setLoadingLevel] = useState(false);
    const [loadingKelas, setLoadingKelas] = useState(false);
    
    
    // Table data
    const [getData, setGetData] = useState([]);


    const [modalDetailOpen, setModalDetailOpen] = useState(false);
    const [selectedDetail, setSelectedDetail] = useState(null);
    const [isSavingDetail, setIsSavingDetail] = useState(false);

    // Search
    const [searchKeyword, setSearchKeyword] = useState("");
    const [tablePage, setTablePage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    // UI state
    const [hasSearched, setHasSearched] = useState(false);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [isFilterDirty, setIsFilterDirty] = useState(false);
    const [isFetching, setIsFetching] = useState(false);

    const [namaTA, setNamaTA] = useState("");
    const [namaSmstr, setNamaSmstr] = useState("");

    const isLoadingTambahNisn = false;


    // Filter form
    const [form2, setForm2] = useState({
      ysb_semester_id: "",
      ysb_branch_id: "",
      ysb_school_id: "",
      ysb_grade_level_id:"",
      ysb_kelas_id:"",
    });

    const currentDate = new Date();

    const [filterMonthYear, setFilterMonthYear] = useState({
      ysb_month_id: String(currentDate.getMonth() + 1),
      att_year: String(currentDate.getFullYear()),
    });

    const monthOptions = [
      { value: "1", label: "Januari" },
      { value: "2", label: "Februari" },
      { value: "3", label: "Maret" },
      { value: "4", label: "April" },
      { value: "5", label: "Mei" },
      { value: "6", label: "Juni" },
      { value: "7", label: "Juli" },
      { value: "8", label: "Agustus" },
      { value: "9", label: "September" },
      { value: "10", label: "Oktober" },
      { value: "11", label: "November" },
      { value: "12", label: "Desember" },
    ];

    const yearOptions = Array.from({ length: 5 }, (_, i) => {
      const year = currentDate.getFullYear() - 2 + i;
      return String(year);
    });


    // Permission
    const location = useLocation();
    const [, setPermission] = useState({
      create: 0,
      read: 0,
      update: 0,
      delete: 0,
    });

    const navigate = useNavigate();
    
    useEffect(() => {
      const level = localStorage.getItem("level");
      const storageItems = JSON.parse(localStorage.getItem("role_permission")) || [];
      if (level === "developer" || level === "superadmin") {
        setPermission({ create: 1, read: 1, update: 1, delete: 1 });
        return;
      }
      const foundPermission = storageItems.find((item) => item.menu?.url === location.pathname);
      if (!foundPermission) navigate("/dashboard");
      else {
        setPermission({
        create: foundPermission.create,
        read: foundPermission.read,
        update: foundPermission.update,
        delete: foundPermission.delete,
        });
      }
    }, [location.pathname, navigate]);
    
    /* API HEADERS */
    const fetchParams = useMemo(
      () => ({
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      }), [token]
    );
    
    // ---------- helper refs ----------
    const isMounted = useRef(true);
    const abortControllers = useRef([]);
    
    useEffect(() => {
      return () => {
        isMounted.current = false;
        abortControllers.current.forEach((c) => c.abort());
      };
    }, []);
    
    const collator = useMemo(() => new Intl.Collator("id", { numeric: true, sensitivity: "base" }), []);
      
    const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

    // SORT sekolah
    const sortSchools = (schools) => {
      const order = ["SD", "SMP", "SMA"];
      return [...schools].sort((a, b) => {
        const jenjangA = order.findIndex((j) => (a.school_name || "").toUpperCase().includes(j));
        const jenjangB = order.findIndex((j) => (b.school_name || "").toUpperCase().includes(j));
        return jenjangA - jenjangB;
      });
    };

    const removeBasementBekasi = (schools, branchId) => {
      if (branchId === "BKS") return schools.filter((s) => s.school_code !== "BASEMENT_BEKASI");
      return schools;
    };

    const fetchCabang = async () => {
        setLoading(true);
        const response = await APIMS.get(
            `/api/access/branches?page=1&limit=1000&ascending=${ascending}&search=`,
            fetchParams
        );

        // Branch default pertama
        if (response?.status === 200) {
          const branches = response.data.data || [];
          setGetDataBranch(branches);
          if (branches.length > 0) {
            const firstBranch = branches[0].branch_code;
            setForm2((prev) => ({ ...prev, ysb_branch_id: firstBranch }));
          }
        }
    } 

    useEffect(() => {
        fetchCabang();
    }, [])

    const fetchSemester = async () => {
        setLoading(true);
        const response = await APIMS.get(
            `/api/access/semesters?page=1&limit=1000&ascending=${ascending}&search=`,
            fetchParams
        );

        // Semester aktif
        if (response?.status === 200) {
          const semesters = response.data.data || [];
          const active = semesters.find((s) => s.status === 1) || semesters[0];
          setGetDataSemesterMap(semesters);
          if (active) {
            setNamaTA(active.name_year || "");
            setNamaSmstr(active.semester || "");
            setForm2((prev) => ({ ...prev, ysb_semester_id: active.id }));
          }
        }
    } 

    useEffect(() => {
        fetchSemester();
    }, [])

    const fetchSchoolsByBranch = useCallback(
      async (branchId) => {
        initSchoolDone.current = false;
        initLevelDone.current = false;
        initKelasDone.current = false;
        setLoadingSchool(true); 
        try {
          const res = await APIMS.get(
            `/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
            fetchParams
          );
          if (res?.status === 200) {
            let schools = res.data.data || [];

            if (storageLevel === "developer" || storageLevel === "superadmin") {
              schools = schools.filter(
                (s) => s.ysb_branch_id === branchId
              );
            }

            schools = removeBasementBekasi(schools, branchId);
            schools = sortSchools(schools);

            setGetDataSchool(schools);

            // default sekolah pertama
            if (schools.length > 0) {
              // reset dependensi saat sekolah berubah (tingkatan/kelas)
              setGetDataLevel([]);
              setGetDataKelas([]);
              setForm2((prev) => ({
                ...prev,
                ysb_school_id: schools[0].school_code,
                ysb_grade_level_id: "",
                ysb_kelas_id: "",
              }));
            } else {
              setGetDataLevel([]);
              setGetDataKelas([]);
              setForm2((prev) => ({ ...prev, ysb_school_id: "", ysb_grade_level_id: "", ysb_kelas_id: "" }));
            }
          }
        } catch (err) {
          console.log(err);
        } finally {
            initSchoolDone.current = true;
            setLoadingSchool(false); 
            setLoading(false);       
        }
      },[ascending, fetchParams, limit, page, storageLevel]
    );

    useEffect(() => {
      if (form2.ysb_branch_id) fetchSchoolsByBranch(form2.ysb_branch_id);
    }, [form2.ysb_branch_id, fetchSchoolsByBranch]);


    // =========================
    // Fetch tingkatan saat sekolah berubah
    // =========================
    const sortLevels = (levels) => {
      return [...levels].sort((a, b) =>
        (a?.name_level || "").localeCompare((b?.name_level || ""), "id", { numeric: true, sensitivity: "base" })
      );
    };

    const sortKelas = (kelas) => {
      return [...kelas].sort((a, b) =>
        (a?.name_kelas || "").localeCompare((b?.name_kelas || ""), "id", { numeric: true, sensitivity: "base" })
      );
    };

    const fetchLevelsBySchool = useCallback(
      async (schoolId, branchId) => {
        initLevelDone.current = false;
        initKelasDone.current = false; 
        if (!schoolId) return;

        setLoadingLevel(true);
        try {
          const res = await APIMS.get(
            `/api/grade-levels?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
            fetchParams
          );

          if (res?.status === 200) {
            let levels = res.data?.data || [];

           
            levels = levels.filter((x) => x?.ysb_school_id === schoolId);
            if (branchId) levels = levels.filter((x) => x?.ysb_branch_id === branchId);

            levels = sortLevels(levels);
            setGetDataLevel(levels);

            if (levels.length === 0) {
              initKelasDone.current = true;
            }

            // default tingkatan pertama
            if (levels.length > 0) {
              setForm2((prev) => ({
                ...prev,
                ysb_grade_level_id: levels[0].id,
              }));
            } else {
              setForm2((prev) => ({
                ...prev,
                ysb_grade_level_id: "",
                ysb_kelas_id: "",
              }));

            setGetDataKelas([]);
            }
          }
        } catch (err) {
          console.error(err);
          swal({
            title: "Failed",
            text: err?.response?.data?.message || err.message || "Gagal mengambil data tingkatan",
            icon: "error",
            timer: 3000,
            buttons: false,
          });

          setGetDataLevel([]);
          setGetDataKelas([]);
          setForm2((prev) => ({ ...prev, ysb_grade_level_id: "", ysb_kelas_id: "" }));

        } finally {
          initLevelDone.current = true;
          setLoadingLevel(false);
        }
      }, [fetchParams]
    );

   
    useEffect(() => {
      if (!form2.ysb_school_id) {
        setGetDataLevel([]);
        setGetDataKelas([]);
        setForm2((prev) => ({ ...prev, ysb_grade_level_id: "", ysb_kelas_id: "" }));
      return;
      }

      setGetDataLevel([]);
      setGetDataKelas([]);
      setForm2((prev) => ({ ...prev, ysb_grade_level_id: "", ysb_kelas_id: "" }));
      fetchLevelsBySchool(form2.ysb_school_id, form2.ysb_branch_id);
    }, [form2.ysb_school_id, form2.ysb_branch_id, fetchLevelsBySchool]);

    // =========================
    // Fetch kelas saat tingkatan berubah
    // =========================
    const fetchKelasByLevel = useCallback(
      async (gradeLevelId, schoolId, branchId) => {
        initKelasDone.current = false;

        if (!gradeLevelId) return;

        setLoadingKelas(true);
        try {
          const res = await APIMS.get(
            `/api/kelas?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
            fetchParams
          );

          if (res?.status === 200) {
            let kelas = res.data?.data || [];

            kelas = kelas.filter((x) => x?.ysb_grade_level_id === gradeLevelId);
            if (schoolId) kelas = kelas.filter((x) => x?.ysb_school_id === schoolId);
            if (branchId) kelas = kelas.filter((x) => x?.ysb_branch_id === branchId);

            kelas = sortKelas(kelas);
            setGetDataKelas(kelas);

            // default kelas pertama
            if (kelas.length > 0) {
              setForm2((prev) => ({
                ...prev,
                ysb_kelas_id: kelas[0].id,
              }));
            } else {
              setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
            }
          }
        } catch (err) {
          console.error(err);
          swal({
            title: "Failed",
            text: err?.response?.data?.message || err.message || "Gagal mengambil data kelas",
            icon: "error",
            timer: 3000,
            buttons: false,
          });
          setGetDataKelas([]);
          setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
        } finally {
          initKelasDone.current = true;
          setLoadingKelas(false);
        }
      }, [fetchParams]
    );

    useEffect(() => {
      if (!form2.ysb_grade_level_id) {
        setGetDataKelas([]);
        setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
        return;
      }

      setGetDataKelas([]);
      setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
      fetchKelasByLevel(form2.ysb_grade_level_id, form2.ysb_school_id, form2.ysb_branch_id);
    }, [form2.ysb_grade_level_id, form2.ysb_school_id, form2.ysb_branch_id, fetchKelasByLevel]);

  
    // =========================
    // Filter complete
    // =========================
    const isFilterComplete =
      isFilterDirty &&
      !!form2.ysb_semester_id &&
      !!form2.ysb_branch_id &&
      !!form2.ysb_school_id &&
      (!loadingLevel && (getDataLevel.length === 0 || !!form2.ysb_grade_level_id)) &&
      (!loadingKelas && (getDataKelas.length === 0 || !!form2.ysb_kelas_id));

    // =========================
    // Fetch table data
    // =========================
    const GetResponseData = useCallback(async () => {
      if (
        !form2.ysb_semester_id ||
        !form2.ysb_branch_id ||
        !form2.ysb_school_id 
      ) return;

      setIsFetching(true);
      const params = {
        ysb_semester_id: form2.ysb_semester_id,
        level: storageLevel,
        ysb_branch_id: form2.ysb_branch_id,
        ysb_school_id: form2.ysb_school_id,
        ysb_month_id: filterMonthYear.ysb_month_id,
        att_year: filterMonthYear.att_year
      };

      if (form2.ysb_grade_level_id) {
        params.ysb_grade_level_id = form2.ysb_grade_level_id;
      }
      if (form2.ysb_kelas_id) {
        params.ysb_kelas_id = form2.ysb_kelas_id;
      }

      try {
        const response = await APISD.post(
          // "/api/config-auth-students-super/index",
          "/api/absen-dailys-super/request",
          
          
          params,
          fetchParams,
        
        );

      if (response?.status === 200) {
        // setGetData(response.data || []);
        const rows = response.data?.data || [];
        setGetData(Array.isArray(rows) ? rows : []);

      }
      } catch (error) {
        swal({
          title: "Gagal",
          text: error?.response?.data?.message || "Gagal mengambil data",
          icon: "error",
        });
      } finally {
        setIsFetching(false);
      }
    }, [form2, filterMonthYear, fetchParams, storageLevel]);

    // AUTO LOAD
    useEffect(() => {
      const schoolReady =
        initSchoolDone.current &&
        !loadingSchool &&
        !!form2.ysb_school_id;

      const gradeReady =
        initLevelDone.current &&
        !loadingLevel &&
        (getDataLevel.length === 0 || !!form2.ysb_grade_level_id);

      const kelasReady =
        initKelasDone.current &&
        !loadingKelas &&
        (getDataKelas.length === 0 || !!form2.ysb_kelas_id);

      if (
        firstLoadDone.current ||
        !form2.ysb_semester_id ||
        !form2.ysb_branch_id ||
        !schoolReady ||
        !gradeReady ||
        !kelasReady
      ) return;

      firstLoadDone.current = true;

      (async () => {
        setIsFetching(true);
        await GetResponseData(); 
        setHasSearched(true);
        setIsFirstLoad(false);
        setIsFilterDirty(false);
        setIsFetching(false);
      })();
    }, [
      form2.ysb_semester_id,
      form2.ysb_branch_id,
      form2.ysb_school_id,
      form2.ysb_grade_level_id,
      form2.ysb_kelas_id,
      loadingSchool,
      loadingLevel,
      loadingKelas,
      getDataLevel.length,
      getDataKelas.length,
    ]);


    // =========================
    // HANDLER perubahan filter 
    // =========================
    const handleChange = (e) => {
      const { name, value } = e.target;

      setForm2((prev) => ({ ...prev, [name]: value }));

      if (!isFirstLoad) {
        setIsFilterDirty(true);
        setHasSearched(false);
      }
    };

    const handleMonthYearChange = (e) => {
      const { name, value } = e.target;

      setFilterMonthYear((prev) => ({ ...prev, [name]: value }));

      if (!isFirstLoad) {
        setIsFilterDirty(true);
        setHasSearched(false);
      }
    };

    // =========================
    // BUTTON CARI
    // =========================
    const handleCari = async () => {
      
      if (loadingSchool || loadingLevel || loadingKelas) {
        swal({
          title: "Mohon tunggu",
          text: "Data sekolah/tingkatan/kelas masih dimuat. Coba lagi sebentar.",
          icon: "info",
          timer: 2200,
          buttons: false,
        });
        return;
      }

      const gradeRequired = getDataLevel.length === 0 ? true : !!form2.ysb_grade_level_id;
      const kelasRequired = getDataKelas.length === 0 ? true : !!form2.ysb_kelas_id;

      if (!form2.ysb_semester_id || !form2.ysb_branch_id || !form2.ysb_school_id || !gradeRequired || !kelasRequired) {
        swal({
          title: "Filter belum lengkap",
          text: "Pastikan Semester, Cabang, Sekolah, Tingkatan,dan Kelas sudah dipilih.",
          icon: "warning",
        });
        return;
      }

      setGetData([]);
      setHasSearched(false);
      setIsFetching(true);
      setSearchKeyword("");

      try {
        await GetResponseData();
        setHasSearched(true);
        setIsFilterDirty(false);
      } catch (err) {
        swal({
          title: "Failed",
          text: err?.response?.data?.message || "Terjadi kesalahan",
          icon: "error",
        });
      } finally {
        setIsFetching(false);
      }
    };

    // =========================
    // Filter + Search + Sorting
    // =========================
    const displayedData = useMemo(() => {
      let rows = Array.isArray(getData) ? [...getData] : [];

      const q = safeStr(searchKeyword).trim().toLowerCase();

      if (q) {
        rows = rows.filter((r) => {
          const nama = safeStr(r?.name_student).toLowerCase();
          const nisn = safeStr(r?.nisn_student).toLowerCase();

          return nama.includes(q) || nisn.includes(q);
        });
      }

      rows.sort((a, b) =>
        collator.compare(
          safeStr(a?.name_student),
          safeStr(b?.name_student)
        )
      );

      return rows;
    }, [collator, getData, searchKeyword]);

    useEffect(() => {
      setTablePage(1);
    }, [searchKeyword, pageSize, getData]);

    const totalPages = Math.max(1, Math.ceil(displayedData.length / pageSize));
    const currentPage = Math.min(tablePage, totalPages);
    const startIndex = (currentPage - 1) * pageSize;
    const paginatedData = displayedData.slice(startIndex, startIndex + pageSize);

    const visiblePages = useMemo(() => {
      const pages = [];
      const from = Math.max(1, currentPage - 1);
      const to = Math.min(totalPages, currentPage + 1);
      for (let i = from; i <= to; i += 1) pages.push(i);
      return pages;
    }, [currentPage, totalPages]);
  
    // =========================
    const toTitleCase = (value) => {
      const s = safeStr(value).toLowerCase().trim();
      if (!s) return "";
      return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
    };


    const toggleModalDetail = () => {
  setModalDetailOpen((prev) => !prev);
};

const handleOpenDetail = (row) => {
  setSelectedDetail(row);
  setModalDetailOpen(true);
};

// const handleSaveDetail = async (payload) => {
//   console.log("Payload modal detail:", payload);

//   // Nanti kalau endpoint save/update sudah ada,
//   // tinggal isi proses API di sini.
//   setIsSavingDetail(true);

//   try {
//     // contoh:
//     // await APILA.post("/api/endpoint-koreksi-absen/store", {
//     //   ysb_student_id: payload?.selectedData?.ysb_student_id,
//     //   tanggal: payload.tanggal,
//     //   jam_masuk: payload.jam_masuk,
//     //   jam_pulang: payload.jam_pulang,
//     //   catatan: payload.catatan,
//     //   ysb_semester_id: form2.ysb_semester_id,
//     //   ysb_branch_id: form2.ysb_branch_id,
//     //   ysb_school_id: form2.ysb_school_id,
//     //   ysb_grade_level_id: form2.ysb_grade_level_id,
//     //   ysb_kelas_id: form2.ysb_kelas_id,
//     // }, fetchParams);
    

//     swal({
//       title: "Berhasil",
//       text: "Data detail absensi berhasil disiapkan.",
//       icon: "success",
//       timer: 2000,
//       buttons: false,
//     });

//     setModalDetailOpen(false);
//   } catch (error) {
//     swal({
//       title: "Gagal",
//       text: error?.response?.data?.message || "Gagal menyimpan detail absensi",
//       icon: "error",
//     });
//   } finally {
//     setIsSavingDetail(false);
//   }
// };


const handleSaveDetail = async (payload) => {
  setIsSavingDetail(true);

  try {
    const selected = payload?.selectedData || selectedDetail || {};

    const body = {
      ysb_semester_id: form2.ysb_semester_id,
      ysb_branch_id: form2.ysb_branch_id,
      ysb_school_id: form2.ysb_school_id,
      ysb_student_id: selected?.ysb_student_id || selected?.id || "",
      att_date: payload?.tanggal || new Date().toISOString().slice(0, 10),
      in_time: payload?.jam_masuk || "",
      out_time: payload?.jam_pulang || "",
      scedule_in: payload?.schedule_in || payload?.scedule_in || "07:00:00",
      note: payload?.catatan || "",
      type_koreksi: Number(payload?.type_koreksi || payload?.tipe_koreksi || 0),
      user_id: output_id_user,
    };

    await APISD.post(
      "/api/absen-dailys-super/store",
      body,
      fetchParams
    );

    swal({
      title: "Berhasil",
      text: "Data koreksi absensi berhasil disimpan.",
      icon: "success",
      timer: 2000,
      buttons: false,
    });

    setModalDetailOpen(false);
    setSelectedDetail(null);

    // refresh table setelah simpan
    await GetResponseData();
    setHasSearched(true);
  } catch (error) {
    console.log("Error save koreksi absen:", error?.response || error);

    swal({
      title: "Gagal",
      text:
        error?.response?.data?.message ||
        "Gagal menyimpan koreksi absensi",
      icon: "error",
    });
  } finally {
    setIsSavingDetail(false);
  }
};




    const masterLoading = loading || loadingSchool || loadingLevel || loadingKelas;

    return (
      <div className="ka-page">
        <style>{css}</style>

        <ModalDetailKoreksiAbsen
          isOpen={modalDetailOpen}
          toggle={toggleModalDetail}
          selectedData={selectedDetail}
          onSave={handleSaveDetail}
          isSaving={isSavingDetail}
        />

        <div className="ka-filter-card">
          {/* <div className="ka-filter-header">
            <div className="ka-filter-title-wrap">
              <span className="ka-filter-icon">
                <FilterIcon />
              </span>
              <div>
                <h5 className="ka-filter-title">Filter Koreksi Absensi</h5>
                <p className="ka-filter-subtitle">
                  Pilih periode dan kelas untuk menampilkan rekap absensi siswa.
                </p>
              </div>
            </div>
          </div> */}

          {masterLoading && !firstLoadDone.current ? (
            <>
              <div className="ka-filter-grid">
                {Array.from({ length: 7 }).map((_, index) => (
                  <div className="ka-field" key={index}>
                    <div className="ka-shimmer ka-shimmer-label" />
                    <div className="ka-shimmer ka-shimmer-control" />
                  </div>
                ))}
              </div>
              {/* <div className="ka-filter-actions">
                <div className="ka-shimmer ka-shimmer-button" />
                <div className="ka-shimmer ka-shimmer-button" />
              </div> */}
            </>
          ) : (
            <>
              <div className="ka-filter-grid">
                <div className="ka-field">
                  <label className="ka-label">Tahun Ajaran / Semester</label>
                  <div className="ka-select-wrap">
                    <select
                      className="ka-select"
                      name="ysb_semester_id"
                      value={form2.ysb_semester_id}
                      onChange={handleChange}
                    >
                      <option value="" hidden>
                        {namaTA ? `${namaTA} (Semester ${namaSmstr})` : "Pilih Semester"}
                      </option>
                      {getDataSemesterMap.map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.name_year} (Semester {item?.semester})
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="ka-field">
                  <label className="ka-label">Cabang</label>
                  <div className="ka-select-wrap">
                    <select
                      className="ka-select"
                      name="ysb_branch_id"
                      value={form2.ysb_branch_id}
                      onChange={handleChange}
                    >
                      <option value="" hidden>Pilih Cabang</option>
                      {getDataBranch.map((item) => (
                        <option key={item?.branch_code} value={item?.branch_code}>
                          {item?.branch_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="ka-field">
                  <label className="ka-label">Sekolah</label>
                  <div className="ka-select-wrap">
                    <select
                      className="ka-select"
                      name="ysb_school_id"
                      value={form2.ysb_school_id}
                      onChange={handleChange}
                      disabled={loadingSchool || !form2.ysb_branch_id}
                    >
                      <option value="" hidden>
                        {loadingSchool ? "Memuat sekolah..." : "Pilih Sekolah"}
                      </option>
                      {getDataSchool.map((item) => (
                        <option key={item?.school_code} value={item?.school_code}>
                          {item?.school_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="ka-field">
                  <label className="ka-label">Tingkatan</label>
                  <div className="ka-select-wrap">
                    <select
                      className="ka-select"
                      name="ysb_grade_level_id"
                      value={form2.ysb_grade_level_id}
                      onChange={handleChange}
                      disabled={loadingLevel || !form2.ysb_school_id}
                    >
                      <option value="" hidden>
                        {loadingLevel ? "Memuat tingkatan..." : "Pilih Tingkatan"}
                      </option>
                      {getDataLevel.map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.name_level}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="ka-field">
                  <label className="ka-label">Kelas</label>
                  <div className="ka-select-wrap">
                    <select
                      className="ka-select"
                      name="ysb_kelas_id"
                      value={form2.ysb_kelas_id}
                      onChange={handleChange}
                      disabled={loadingKelas || !form2.ysb_grade_level_id}
                    >
                      <option value="" hidden>
                        {loadingKelas ? "Memuat kelas..." : "Pilih Kelas"}
                      </option>
                      {getDataKelas.map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.name_kelas}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="ka-field">
                  <label className="ka-label">Bulan</label>
                  <div className="ka-select-wrap">
                    <select
                      className="ka-select"
                      name="ysb_month_id"
                      value={filterMonthYear.ysb_month_id}
                      onChange={handleMonthYearChange}
                    >
                      {monthOptions.map((month) => (
                        <option key={month.value} value={month.value}>
                          {month.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="ka-field">
                  <label className="ka-label">Tahun</label>
                  <div className="ka-select-wrap">
                    <select
                      className="ka-select"
                      name="att_year"
                      value={filterMonthYear.att_year}
                      onChange={handleMonthYearChange}
                    >
                      {yearOptions.map((year) => (
                        <option key={year} value={year}>{year}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <button
                  type="button"
                  className="ka-btn ka-btn-filter"
                  onClick={handleCari}
                  disabled={!isFilterComplete || isFetching}
                >
                  {isFetching ? (
                    <>
                      <span className="ka-spinner" />
                      Memuat...
                    </>
                  ) : (
                    "Tampilkan Data"
                  )}
                </button>
              </div>

              {/* <div className="ka-filter-actions mt-4">
                <button
                  type="button"
                  className="ka-btn ka-btn-download"
                  disabled={isLoadingTambahNisn}
                >
                  {isLoadingTambahNisn ? (
                    <>
                      <span className="ka-spinner" />
                      Memuat...
                    </>
                  ) : (
                    <>
                      <DownloadIcon />
                      Unduh Data Absensi
                    </>
                  )}
                </button>

                
              </div> */}
            </>
          )}
        </div>

        {(hasSearched || isFetching) && (
          <>
            <div className="ka-toolbar mt-4">
              <div className="ka-search-wrap">
                <span className="ka-search-icon">
                  <SearchIcon />
                </span>
                <input
                  type="text"
                  className="ka-search-input"
                  placeholder="Cari nama siswa atau NISN..."
                  value={searchKeyword}
                  onChange={(e) => setSearchKeyword(e.target.value)}
                  disabled={isFetching}
                />
              </div>

              <div className="ml-auto">
                {/* <span className="ka-total-badge mr-2">
                  Total {displayedData.length} siswa
                </span> */}
                
                <button
                  type="button"
                  className="ka-btn ka-btn-download"
                  disabled={isLoadingTambahNisn}
                >
                  {isLoadingTambahNisn ? (
                    <>
                      <span className="ka-spinner" />
                      Memuat...
                    </>
                  ) : (
                    <>
                      <DownloadIcon />
                      Unduh Data Absensi
                    </>
                  )}
                </button>
              </div>

              {/* <span className="ka-total-badge">
                Total {displayedData.length} siswa
              </span>
              <button
                  type="button"
                  className="ka-btn ka-btn-download"
                  disabled={isLoadingTambahNisn}
                >
                  {isLoadingTambahNisn ? (
                    <>
                      <span className="ka-spinner" />
                      Memuat...
                    </>
                  ) : (
                    <>
                      <DownloadIcon />
                      Unduh Data Absensi
                    </>
                  )}
                </button> */}
            </div>

            {isFetching ? (
              <div className="ka-loading-card">
                <div className="ka-loading-head" />
                <div className="ka-table-scroll">
                  {Array.from({ length: 6 }).map((_, index) => (
                    <div className="ka-loading-row" key={index}>
                      <div className="ka-shimmer ka-loading-line no" />
                      <div className="ka-shimmer ka-loading-line name" />
                      <div className="ka-shimmer ka-loading-line count" />
                      <div className="ka-shimmer ka-loading-line count" />
                      <div className="ka-shimmer ka-loading-line count" />
                      <div className="ka-shimmer ka-loading-line count" />
                      <div className="ka-shimmer ka-loading-line action" />
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className="ka-table-card">
                <div className="ka-table-scroll">
                  <table className="ka-table">
                    <thead>
                      <tr>
                        <th className="ka-col-number">No</th>
                        <th className="ka-col-name">Nama Siswa</th>
                        <th className="ka-col-count">Hadir</th>
                        <th className="ka-col-count">Alpa</th>
                        <th className="ka-col-count">Sakit</th>
                        <th className="ka-col-count">Izin</th>
                        <th className="ka-col-action">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedData.length === 0 ? (
                        <tr>
                          <td colSpan={7} className="ka-empty-state">
                            Data siswa tidak ditemukan.
                          </td>
                        </tr>
                      ) : (
                        paginatedData.map((row, index) => (
                          <tr key={row?.ysb_student_id || row?.id || `${currentPage}-${index}`}>
                            <td className="ka-col-number">
                              <span className="ka-number-badge">
                                {startIndex + index + 1}
                              </span>
                            </td>
                            <td>
                              <span className="ka-student-name">
                                {toTitleCase(row?.name_student)}
                              </span>
                            </td>
                            <td className="ka-col-count">
                              <span className="ka-count-badge">{row?.total_kehadiran ?? 0}</span>
                            </td>
                            <td className="ka-col-count">
                              <span className="ka-count-badge">{row?.total_alpha ?? 0}</span>
                            </td>
                            <td className="ka-col-count">
                              <span className="ka-count-badge">{row?.total_sakit ?? 0}</span>
                            </td>
                            <td className="ka-col-count">
                              <span className="ka-count-badge">{row?.total_izin ?? 0}</span>
                            </td>
                            <td className="ka-col-action">
                              <div className="ka-action-wrap">
                                <button
                                  type="button"
                                  className="ka-action-button"
                                  onClick={() => handleOpenDetail(row)}
                                  title="Koreksi absensi siswa"
                                >
                                  <FontAwesomeIcon icon={faGear} />
                                  Koreksi
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>

                {displayedData.length > 0 && (
                  <div className="ka-pagination">
                    <div className="ka-pagination-left">
                      <span className="ka-page-info">
                        Menampilkan <b>{startIndex + 1}</b>–<b>{Math.min(startIndex + pageSize, displayedData.length)}</b> dari <b>{displayedData.length}</b>
                      </span>
                      <select
                        className="ka-page-size"
                        value={pageSize}
                        onChange={(e) => setPageSize(Number(e.target.value))}
                      >
                        <option value={10}>10 per halaman</option>
                        <option value={25}>25 per halaman</option>
                        <option value={50}>50 per halaman</option>
                      </select>
                    </div>

                    <div className="ka-pagination-right">
                      <button
                        type="button"
                        className="ka-page-btn"
                        onClick={() => setTablePage((prev) => Math.max(1, prev - 1))}
                        disabled={currentPage <= 1}
                      >
                        Prev
                      </button>

                      <div className="ka-page-numbers">
                        {visiblePages.map((pageNumber) => (
                          <button
                            type="button"
                            key={pageNumber}
                            className={`ka-page-btn ${currentPage === pageNumber ? "active" : ""}`}
                            onClick={() => setTablePage(pageNumber)}
                          >
                            {pageNumber}
                          </button>
                        ))}
                      </div>

                      <button
                        type="button"
                        className="ka-page-btn"
                        onClick={() => setTablePage((prev) => Math.min(totalPages, prev + 1))}
                        disabled={currentPage >= totalPages}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
    );
}
